'use client'

import type { ReactNode } from 'react'
import { useExtracted } from 'next-intl'
import { MartiniLoader } from '@/components/MartiniLoader'
import { cn } from '@/lib/utils'

interface ProjectBootScreenProps {
  className?: string
  /** Defaults to "Preparing your martini..." */
  message?: string
  /** Secondary line, e.g. a stuck-detector hint. */
  detail?: string
  /** Recovery action rendered under the detail (e.g. a Refresh button). */
  action?: ReactNode
}

/**
 * Full-screen boot loader shown while a project editor session initializes.
 * Reused for route loading boundaries, navigation overlays, and in-editor boot.
 */
export function ProjectBootScreen({ className, message, detail, action }: ProjectBootScreenProps) {
  const t = useExtracted()
  const label = message ?? t('Preparing your martini...')

  return (
    <div
      className={cn('h-screen w-screen flex flex-col items-center justify-center gap-2 px-6 bg-background', className)}
    >
      <MartiniLoader className="text-foreground" />
      <span className="text-sm text-muted-foreground">{label}</span>
      {detail && <span className="text-xs text-muted-foreground/70">{detail}</span>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  )
}
